// extracted by mini-css-extract-plugin
export var content = "_70-3";
export var list = "_70-4";
export var settingsContent = "_70-7";
export var settingsPanel = "_70-8";
export var state = "_70-6";
export var triggerBadge = "_70-2";
export var triggerButton = "_70-1";
export var triggerShell = "_70-0";
export var unreadDot = "_70-5";